module.exports = __webpack_public_path__ + "static/jujubee-header-desktop-da6b096351b7855d198d8411adb8a395.jpg";